import React, { useState, useEffect } from "react";
import "./App.css";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import WhyChooseUs from "./components/WhyChooseUs";
import ServicesSection from "./components/ServicesSection";
import GallerySection from "./components/GallerySection";
import BookingSection from "./components/BookingSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

import { Toaster } from "./components/ui/toaster";

/* ⭐ YOUR NEW SERVICE PAGES */
import ThaiDryMassage from "./components/services/ThaiDryMassage";
import AromaMassage from "./components/services/AromaMassage";
import SwedishMassage from "./components/services/SwedishMassage";
import BalineseMassage from "./components/services/BalineseMassage";
import DeepTissueMassage from "./components/services/DeepTissueMassage";

/* ⭐ FIXED — FILE NAME IS BodyScrub.jsx */
import BodyScrub from "./components/services/BodyScrub";

function App() {
  const [activeSection, setActiveSection] = useState("home");

  // ⭐ SCROLL TO TOP ON PAGE CHANGE
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeSection]);

  return (
    <div className="App">

      <Header setActiveSection={setActiveSection} />

      {activeSection === "home" && (
        <>
          <HeroSection setActiveSection={setActiveSection} />

          <AboutSection 
            setActiveSection={setActiveSection} 
            activeSection="home"
          />

          <WhyChooseUs />

          <ServicesSection 
            setActiveSection={setActiveSection}
            activeSection="home"
          />

          <GallerySection 
            setActiveSection={setActiveSection}
            activeSection="home"
          />

          <ContactSection />

          <BookingSection />
        </>
      )}

      {activeSection === "about" && (
        <AboutSection 
          setActiveSection={setActiveSection}
          activeSection="about"
        />
      )}

      {activeSection === "why" && <WhyChooseUs />}

      {activeSection === "services" && (
        <ServicesSection 
          setActiveSection={setActiveSection}
          activeSection="services"
        />
      )}

      {activeSection === "gallery" && (
        <GallerySection 
          setActiveSection={setActiveSection}
          activeSection="gallery"
        />
      )}

      {/* ⭐ Contact Page */}
      {activeSection === "contact" && (
        <ContactSection 
          setActiveSection={setActiveSection}
          activeSection="contact"
        />
      )}

      {activeSection === "booking" && <BookingSection />}

      {/* ⭐ SERVICE DETAIL PAGES */}
      {activeSection === "thai" && (
        <ThaiDryMassage setActiveSection={setActiveSection} />
      )}

      {activeSection === "aroma" && (
        <AromaMassage setActiveSection={setActiveSection} />
      )}

      {activeSection === "swedish" && (
        <SwedishMassage setActiveSection={setActiveSection} />
      )}

      {activeSection === "balinese" && (
        <BalineseMassage setActiveSection={setActiveSection} />
      )}

      {activeSection === "deep" && (
        <DeepTissueMassage setActiveSection={setActiveSection} />
      )}

      {/* ⭐ FIXED — BODY SCRUB PAGE */}
      {activeSection === "scrub" && (
        <BodyScrub setActiveSection={setActiveSection} />
      )}

      <Footer setActiveSection={setActiveSection} />

      <Toaster />
    </div>
  );
}

export default App;
